import React, { ReactElement } from 'react';

const NotFound = (): ReactElement => (
  <>
    <h2>Not found</h2>
  </>
);

export default NotFound;
